import { render, staticRenderFns } from "./ContactPage.vue?vue&type=template&id=68f4d719&scoped=true&"
import script from "./ContactPage.vue?vue&type=script&lang=js&"
export * from "./ContactPage.vue?vue&type=script&lang=js&"
import style0 from "./ContactPage.vue?vue&type=style&index=0&id=68f4d719&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f4d719",
  null
  
)

export default component.exports